import { Validators } from '@angular/forms';

import { FieldsOptions } from '@sim/form';

export type ClassName =
  'BeneOA' |
  'BeneS' |
  'BeneF' |
  'BeneD' |
  'BeneMI' |
  'DocumentoArc' |
  'DocumentoBib' |
  'Base' |
  'Vocabolario' |
  'Termine' |
  'File' |
  'User' |
  'Role' |
  'Capability' |
  'Session' |
  'Collezione' |
  'Persona';

export type AllowedOperation = Array<'create' | 'read' | 'read+all' | 'update' | 'delete'>;

export interface Role {
  id?: string;
  name: string;
  capabilities: Capability[];
  createdAt?: Date | string;
  accessLevel?: number;
}

export interface Capability {
  /** Example: create_user, edit_user, delete_user */
  id?: string;
  name: string;
  classNames?: ClassName[];
  allowedOperations?: AllowedOperation;
}

export const CapabilityMeta: FieldsOptions<Capability> = {
  id: { validators: Validators.required },
  name: { validators: Validators.required },
};

export const RoleMeta: FieldsOptions<Role> = {
  capabilities: { value: [], type: 'array', controls:  CapabilityMeta },
  name: { validators: [Validators.required] },
};
